"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const merge_1 = __importDefault(require("lodash/merge"));
const ObjectivesClient_1 = require("client/ObjectivesClient");
const ToastContext_1 = require("context/ToastContext");
const UserContext_1 = require("context/UserContext");
const useClickOutside_1 = __importDefault(require("hooks/useClickOutside"));
const DateUtils_1 = require("utils/DateUtils");
const HelperUtils_1 = require("utils/HelperUtils");
const ObjectivesHelper_1 = require("utils/ObjectivesHelper");
const Avatar_1 = __importDefault(require("components/design-system/Avatar"));
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const AvatarGroup_1 = __importDefault(require("components/design-system/avatar-group/AvatarGroup"));
const InlineDialogSelectMultipleUser_1 = __importDefault(require("components/inline-dialog/InlineDialogSelectMultipleUser"));
const ObjectiveProgressSummaryPreview_1 = __importDefault(require("components/objectives/progress-summary/ObjectiveProgressSummaryPreview"));
const ToastNotif_1 = __importDefault(require("components/shared/ToastNotif"));
const TruncateParagraph_1 = __importDefault(require("src/components/shared/TruncateParagraph"));
const ObjectiveProgressSummaryModal = ({ setShowModal, filter, owner, extraFilter, placementId, parentObjective }) => {
    var _a, _b, _c, _d;
    const [objectives, setObjectives] = (0, react_1.useState)([]);
    const [overallProgress, setOverallProgress] = (0, react_1.useState)({});
    const [parentObjectiveOwners, setParentObjectiveOwners] = (0, react_1.useState)([]);
    const [receivers, setReceivers] = (0, react_1.useState)([]);
    const [selectedUsers, setSelectedUsers] = (0, react_1.useState)([{}]);
    const [showDialog, setShowDialog] = (0, react_1.useState)(false);
    const [showPreview, setShowPreview] = (0, react_1.useState)(false);
    const [showToastNotif, setShowToastNotif] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [inlineDialogHorizontalMargin, setInlineDialogHorizontalMargin] = (0, react_1.useState)(0);
    const { user } = (0, UserContext_1.useUser)();
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const receiverRef = (0, react_1.useRef)(null);
    const inlineDialogRef = (0, react_1.useRef)(null);
    (0, useClickOutside_1.default)(inlineDialogRef, () => setShowDialog(false));
    const onClickExport = () => __awaiter(void 0, void 0, void 0, function* () {
        if ((receivers === null || receivers === void 0 ? void 0 : receivers.length) === 0) {
            setShowToastNotif(true);
            setTimeout(() => setShowToastNotif(false), 3000);
        }
        else {
            setShowToastNotif(false);
            setIsLoading(true);
            yield getObjectives();
            yield getOverallProgress();
            setIsLoading(false);
            setShowPreview(true);
        }
    });
    const getObjectives = () => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f;
        const mergedFilter = (0, merge_1.default)((0, ObjectivesHelper_1.restructureFilter)(filter), extraFilter);
        mergedFilter.assigneeId =
            ((_e = mergedFilter === null || mergedFilter === void 0 ? void 0 : mergedFilter.assigneeId) === null || _e === void 0 ? void 0 : _e.length) > 0
                ? (_f = mergedFilter === null || mergedFilter === void 0 ? void 0 : mergedFilter.assigneeId) === null || _f === void 0 ? void 0 : _f.map((id) => parseInt(id))
                : mergedFilter === null || mergedFilter === void 0 ? void 0 : mergedFilter.assigneeId;
        const allParams = Object.assign(Object.assign(Object.assign({ reviewsVisibility: 1, limit: parentObjective ? 24 : 25 }, (placementId && { placementId: placementId })), (parentObjective && {
            parentId: parentObjective === null || parentObjective === void 0 ? void 0 : parentObjective.id,
            sortColumn: 'start_date',
            sortDirection: 'asc',
            caseInsensitive: false,
            goals: 'individual'
        })), mergedFilter);
        const { data } = yield (0, ObjectivesClient_1.getListObjectives)(allParams);
        if (data) {
            setObjectives(data);
        }
    });
    const getOverallProgress = () => __awaiter(void 0, void 0, void 0, function* () {
        const allParams = Object.assign(Object.assign({ assigneeId: owner === null || owner === void 0 ? void 0 : owner.id, parentNotAssignedTo: user === null || user === void 0 ? void 0 : user.id, periodBegin: (0, DateUtils_1.formatTimezone)(`${new Date().getFullYear()}-01-01`, 'start'), periodEndBefore: (0, DateUtils_1.formatTimezone)(`${new Date().getFullYear()}-12-31`, 'end'), state: ['running', 'completed', 'reviewed', 'draft', 'edited'], type: ['goal', 'annual_goal'] }, (placementId && { placementId: placementId })), (!placementId &&
            (owner === null || owner === void 0 ? void 0 : owner.placementId) && { placementId: owner === null || owner === void 0 ? void 0 : owner.placementId }));
        const { data } = yield (0, ObjectivesClient_1.getObjectivesCount)(allParams);
        if (data) {
            setOverallProgress(data);
        }
    });
    const setToast = (type) => {
        var _a, _b;
        const userName = receivers.length == 1
            ? (_a = receivers === null || receivers === void 0 ? void 0 : receivers[0]) === null || _a === void 0 ? void 0 : _a.name
            : (_b = receivers === null || receivers === void 0 ? void 0 : receivers.map((user) => user === null || user === void 0 ? void 0 : user.name)) === null || _b === void 0 ? void 0 : _b.join(', ');
        let message = '';
        switch (type) {
            case 'info':
                message = `Processing ${(owner === null || owner === void 0 ? void 0 : owner.id) === (user === null || user === void 0 ? void 0 : user.id) ? 'your' : (owner === null || owner === void 0 ? void 0 : owner.name) + "'s"} objective summary`;
                break;
            case 'success':
                message = `The summary will be sent to receiver${(receivers === null || receivers === void 0 ? void 0 : receivers.length) === 1 ? "'s" : "s'"} WhatsApp account`;
                break;
            case 'error':
                message = [
                    `Export to ${userName} failed due to no WhatsApp account registered.`,
                    react_1.default.createElement("br", { key: "br" }),
                    'Please add it first then try again.'
                ];
                break;
        }
        addToast({
            title: 'Exporting Image',
            msg: message,
            type: type
        });
    };
    const handleChangeSelectedUsers = (newSelectedUsers) => {
        setReceivers(newSelectedUsers === null || newSelectedUsers === void 0 ? void 0 : newSelectedUsers.map((user) => user === null || user === void 0 ? void 0 : user.user));
        setSelectedUsers(newSelectedUsers);
    };
    (0, react_1.useEffect)(() => {
        setReceivers([user]);
        setSelectedUsers([
            {
                user: user,
                userId: user === null || user === void 0 ? void 0 : user.id
            }
        ]);
    }, [user]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (parentObjective) {
            const tempOwners = [];
            (_a = parentObjective === null || parentObjective === void 0 ? void 0 : parentObjective.involvements) === null || _a === void 0 ? void 0 : _a.map((involvement) => {
                if ((involvement === null || involvement === void 0 ? void 0 : involvement.role) === 'assignee') {
                    tempOwners === null || tempOwners === void 0 ? void 0 : tempOwners.push(involvement === null || involvement === void 0 ? void 0 : involvement.user);
                }
            });
            setParentObjectiveOwners(tempOwners);
        }
    }, [parentObjective]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        typeof ((_a = receiverRef === null || receiverRef === void 0 ? void 0 : receiverRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) == 'number' &&
            setInlineDialogHorizontalMargin((_b = receiverRef === null || receiverRef === void 0 ? void 0 : receiverRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth);
    }, [(_a = receiverRef === null || receiverRef === void 0 ? void 0 : receiverRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal_1.default, { minWidth: 400, onClose: () => setShowModal(false), closeOnClickOutside: false, customClass: !isLoading && showPreview ? 'hidden' : '' },
            react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Objective Progress Summary'), onClose: () => setShowModal(false), useBorder: false }),
            react_1.default.createElement(Modal_1.default.Body, null,
                react_1.default.createElement("div", { className: "px-[24px] py-[4px] w-full" },
                    react_1.default.createElement("p", { className: "typography-paragraph text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)('Please check the detail below before exporting.')),
                    react_1.default.createElement("div", { className: "flex my-[20px]" },
                        react_1.default.createElement("div", { className: "w-[166px] mr-[24px]" },
                            react_1.default.createElement("p", { className: "typography-h200 text-n-900 capitalize mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Owner')),
                            parentObjective && (parentObjectiveOwners === null || parentObjectiveOwners === void 0 ? void 0 : parentObjectiveOwners.length) > 1 ? (react_1.default.createElement(AvatarGroup_1.default, { avatars: parentObjectiveOwners })) : (react_1.default.createElement("div", { className: "flex item-center" },
                                react_1.default.createElement(Avatar_1.default, { name: owner === null || owner === void 0 ? void 0 : owner.name, src: owner === null || owner === void 0 ? void 0 : owner.profilePicture, size: 24 }),
                                react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-paragraph text-n-900 max-w-[132px] ml-[8px]" }, owner === null || owner === void 0 ? void 0 : owner.name)))),
                        react_1.default.createElement("div", { ref: receiverRef },
                            react_1.default.createElement("p", { className: "typography-h200 text-n-900 capitalize mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Receiver')),
                            react_1.default.createElement("div", { className: "w-[166px]", ref: inlineDialogRef },
                                react_1.default.createElement("div", { className: `w-full min-h-[24px] ${(user === null || user === void 0 ? void 0 : user.id) !== (owner === null || owner === void 0 ? void 0 : owner.id) && 'cursor-pointer'}`, onClick: (e) => {
                                        e.stopPropagation();
                                        (user === null || user === void 0 ? void 0 : user.id) !== (owner === null || owner === void 0 ? void 0 : owner.id) && setShowDialog(!showDialog);
                                    } }, (receivers === null || receivers === void 0 ? void 0 : receivers.length) === 1 ? (react_1.default.createElement("div", { className: "flex item-center" },
                                    react_1.default.createElement(Avatar_1.default, { name: (_b = receivers[0]) === null || _b === void 0 ? void 0 : _b.name, src: (_c = receivers[0]) === null || _c === void 0 ? void 0 : _c.profilePicture, size: 24 }),
                                    react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-paragraph text-n-900 max-w-[132px] ml-[8px]" }, (_d = receivers[0]) === null || _d === void 0 ? void 0 : _d.name))) : (react_1.default.createElement(AvatarGroup_1.default, { avatars: receivers }))),
                                showDialog && (react_1.default.createElement(InlineDialogSelectMultipleUser_1.default, { selectedValue: selectedUsers, handleChange: handleChangeSelectedUsers, onCloseDialog: () => setShowDialog(false), position: "left", useTrigger: false, useFloating: true, floatingCustomHorizontalMargin: inlineDialogHorizontalMargin, presetSuggestions: (user === null || user === void 0 ? void 0 : user.id) === (owner === null || owner === void 0 ? void 0 : owner.id) ? [user] : [user, owner] }))))))),
            react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                    text: (0, HelperUtils_1.getObjectiveLocale)('Export'),
                    onClick: () => onClickExport(),
                    isLoading: isLoading
                }, secondaryButton: {
                    text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                    onClick: () => setShowModal(false)
                }, useBorder: false })),
        !isLoading && showPreview && (react_1.default.createElement(ObjectiveProgressSummaryPreview_1.default, { owner: owner || user, receivers: receivers, overallProgress: overallProgress, parentObjective: parentObjective, objectives: objectives, setShowModal: setShowModal, setShowPreview: setShowPreview, setToast: setToast })),
        react_1.default.createElement(ToastNotif_1.default, { showNotif: showToastNotif, message: "Must select at least 1 receiver", warning: true, usePortal: true })));
};
exports.default = ObjectiveProgressSummaryModal;
